module.exports = __webpack_public_path__ + "img/patrulla_ministerial_down.4b2e6b9b.svg";